import { render, staticRenderFns } from "./User.edit.component.vue?vue&type=template&id=24dee1b3&"
import script from "./User.edit.component.vue?vue&type=script&lang=js&"
export * from "./User.edit.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports